export default "__VITE_ASSET__Crw1e_T6__"